import React from 'react'
import './CocktailItem.css'

const CocktailItem = ({id, handleShowCocktailDetails, drink, instruction, imageURL}) => {
    return (
        <>
        <div className="cocktailItem">
            <img loading='lazy' decoding='async' src={imageURL} alt='A1' />
            <h3>{drink}</h3>
            <p>How to prepare: <br />{instruction}...</p>
            <button onClick={()=> handleShowCocktailDetails(id, true)}>View more</button>
        </div>
        
        </>
    )
}

export default CocktailItem
